import { render, staticRenderFns } from "./SelectOriginFund.vue?vue&type=template&id=339167f6&scoped=true"
import script from "./SelectOriginFund.vue?vue&type=script&lang=js"
export * from "./SelectOriginFund.vue?vue&type=script&lang=js"
import style0 from "./SelectOriginFund.vue?vue&type=style&index=0&id=339167f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339167f6",
  null
  
)

export default component.exports